/* Gricci — galeria de produto em grid
   Autônomo: não depende de Flickity, PhotoSwipe ou jQuery.
   - No mobile o próprio grid vira carrossel (scroll-snap, CSS).
     Aqui só sincronizamos os dots e o contador.
   - Lightbox próprio, leve, com teclado e swipe.
   - Ao trocar de variante, rola até a mídia correspondente.
*/
(function () {
  'use strict';

  var galleries = [];

  /* ---------------------------------------------------------------- utils */

  function el(tag, cls, parent) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (parent) parent.appendChild(node);
    return node;
  }

  /* ------------------------------------------------------------- lightbox */

  var Lightbox = {
    root: null,
    img: null,
    closeBtn: null,
    video: null,
    opener: null,
    onClose: null,
    items: [],
    index: 0,

    build: function () {
      if (this.root) return;

      var root = el('div', 'gricci-lb');
      root.setAttribute('role', 'dialog');
      root.setAttribute('aria-modal', 'true');
      root.hidden = true;

      var stage = el('div', 'gricci-lb__stage', root);
      var frame = el('div', 'gricci-lb__frame', stage);
      this.img = el('img', 'gricci-lb__img', frame);
      this.img.alt = '';

      var close = el('button', 'gricci-lb__btn gricci-lb__close', root);
      close.type = 'button';
      close.setAttribute('aria-label', 'Fechar');
      close.innerHTML = '&times;';
      this.closeBtn = close;

      var prev = el('button', 'gricci-lb__btn gricci-lb__prev', root);
      prev.type = 'button';
      prev.setAttribute('aria-label', 'Anterior');
      prev.innerHTML = '&#8249;';

      var next = el('button', 'gricci-lb__btn gricci-lb__next', root);
      next.type = 'button';
      next.setAttribute('aria-label', 'Próxima');
      next.innerHTML = '&#8250;';

      var self = this;
      close.addEventListener('click', function () { self.close(); });
      prev.addEventListener('click', function () { self.go(-1); });
      next.addEventListener('click', function () { self.go(1); });
      root.addEventListener('click', function (e) {
        if (e.target === root || e.target === stage) self.close();
      });

      document.addEventListener('keydown', function (e) {
        if (root.hidden) return;
        if (e.key === 'Escape') self.close();
        if (e.key === 'ArrowLeft') self.go(-1);
        if (e.key === 'ArrowRight') self.go(1);
      });

      var startX = null;
      stage.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) self.go(dx < 0 ? 1 : -1);
        startX = null;
      }, { passive: true });

      document.body.appendChild(root);
      this.root = root;
    },

    open: function (items, index) {
      this.build();
      this.items = items;
      this.index = index || 0;
      this.render();
      this.root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    },

    /* Vídeo inteiro, sem o recorte da célula da galeria. Usa uma cópia do
       <video> da página, que já traz as fontes que a Shopify gerou; a cópia
       sai do DOM ao fechar, então o download para junto. */
    openVideo: function (source, opener, onClose) {
      this.build();
      this.removeVideo();

      var video = source.cloneNode(true);
      video.className = 'gricci-lb__video';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'auto';
      video.addEventListener('click', function () {
        if (video.paused) video.play(); else video.pause();
      });

      this.img.hidden = true;
      this.img.parentNode.appendChild(video);
      this.video = video;
      this.items = [];
      this.opener = opener || null;
      this.onClose = onClose || null;

      this.root.classList.add('is-single', 'is-video');
      this.root.hidden = false;
      document.documentElement.style.overflow = 'hidden';

      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
      this.closeBtn.focus();
    },

    removeVideo: function () {
      if (!this.video) return;
      this.video.pause();
      this.video.parentNode.removeChild(this.video);
      this.video = null;
      this.img.hidden = false;
      this.root.classList.remove('is-video');
    },

    close: function () {
      if (!this.root) return;
      var opener = this.opener;
      var onClose = this.onClose;
      this.removeVideo();
      this.opener = null;
      this.onClose = null;
      this.root.hidden = true;
      document.documentElement.style.overflow = '';
      if (opener) opener.focus();
      if (onClose) onClose();
    },

    go: function (delta) {
      if (this.video || !this.items.length) return;
      this.index = (this.index + delta + this.items.length) % this.items.length;
      this.render();
    },

    render: function () {
      this.img.src = this.items[this.index];
      this.root.classList.toggle('is-single', this.items.length < 2);
    }
  };

  /* -------------------------------------------------------------- galeria */

  function Gallery(root) {
    this.root = root;
    this.track = root.querySelector('[data-gricci-gallery-track]');
    this.items = Array.prototype.slice.call(root.querySelectorAll('[data-gricci-media]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-gricci-dot]'));
    this.counter = root.querySelector('[data-gricci-counter]');
    this.preview = root.querySelector('[data-gricci-preview]');
    this.previewOriginal = null;
    this.active = 0;

    this.bindDots();
    this.bindScroll();
    this.bindZoom();
    this.bindVideo();
  }

  Gallery.prototype.bindDots = function () {
    var self = this;
    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { self.scrollTo(i); });
    });
  };

  Gallery.prototype.bindScroll = function () {
    if (!this.track || !this.items.length) return;
    var self = this;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.55) {
            self.setActive(parseInt(entry.target.getAttribute('data-index'), 10));
          }
        });
      }, { root: this.track, threshold: [0.56] });

      this.items.forEach(function (item) { io.observe(item); });
    }
  };

  Gallery.prototype.setActive = function (index) {
    if (isNaN(index) || index === this.active) return;
    this.active = index;

    this.dots.forEach(function (dot, i) {
      dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    });

    if (this.counter) {
      this.counter.textContent = (index + 1) + '/' + this.items.length;
    }
  };

  Gallery.prototype.scrollTo = function (index) {
    var item = this.items[index];
    if (!item) return;

    if (window.matchMedia('(max-width: 767px)').matches && this.track) {
      this.track.scrollTo({ left: item.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    } else {
      item.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    this.setActive(index);
  };

  Gallery.prototype.scrollToMedia = function (mediaId) {
    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].getAttribute('data-media-id') === String(mediaId)) {
        this.scrollTo(i);
        return true;
      }
    }
    return false;
  };

  /* Vídeo da galeria.
     Na célula ele é só prévia: toca sozinho, mudo e em loop, enquanto estiver
     visível (no mobile, só o slide da vez). Clique em qualquer ponto abre o
     vídeo inteiro no lightbox, porque a célula recorta o vídeo vertical.
     Com "reduzir movimento" ligado no sistema, a prévia fica parada e o vídeo
     só toca no lightbox. */
  Gallery.prototype.bindVideo = function () {
    var items = this.items.filter(function (item) {
      return item.classList.contains('gricci-gallery__item--video');
    });
    if (!items.length) return;

    function play(video) {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    items.forEach(function (item) {
      var video = item.querySelector('video');
      if (!video) return;
      video.addEventListener('playing', function () { item.classList.add('is-playing'); });
      video.addEventListener('pause', function () { item.classList.remove('is-playing'); });
    });

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var visible = [];

    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('video');
          if (!video) return;
          var i = visible.indexOf(video);
          if (entry.isIntersecting) {
            if (i === -1) visible.push(video);
            if (!Lightbox.video) play(video);
          } else {
            if (i !== -1) visible.splice(i, 1);
            video.pause();
          }
        });
      }, { threshold: 0.5 });

      items.forEach(function (item) { io.observe(item); });

      // Aba em segundo plano recusa o play() e o observer não avisa de novo
      // (a visibilidade do item não mudou): retoma quando a aba volta.
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible' && !Lightbox.video) visible.forEach(play);
      });
    }

    this.root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-gricci-video-open]') : null;
      if (!btn) return;
      var item = btn.closest('.gricci-gallery__item--video');
      var video = item && item.querySelector('video');
      if (!video) return;
      e.preventDefault();

      visible.forEach(function (v) { v.pause(); });
      Lightbox.openVideo(video, btn, function () {
        visible.forEach(play);
      });
    });
  };

  Gallery.prototype.bindZoom = function () {
    if (this.root.getAttribute('data-enlarge') !== 'true') return;
    var self = this;

    var sources = Array.prototype.slice
      .call(this.root.querySelectorAll('[data-gricci-zoom]'))
      .map(function (btn) { return btn.getAttribute('data-zoom-src'); });

    this.root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-gricci-zoom]') : null;
      if (!btn) return;
      e.preventDefault();
      Lightbox.open(sources, parseInt(btn.getAttribute('data-zoom-index'), 10) || 0);
    });
  };

  /* Preview de cor: usado pelo agrupamento de cores */
  Gallery.prototype.showPreview = function (src) {
    if (!this.preview || !src) return;
    if (this.previewOriginal === null) this.previewOriginal = this.preview.src;
    this.preview.src = src;
    this.preview.classList.add('is-visible');
  };

  Gallery.prototype.hidePreview = function () {
    if (!this.preview) return;
    this.preview.classList.remove('is-visible');
  };

  /* ---------------------------------------------- sincronia com a variante */

  function watchVariant(section, gallery) {
    if (!section) return;

    function sync() {
      var input = section.querySelector('[name="id"]');
      if (!input || !input.value) return;

      var json = section.querySelector('.product-json');
      if (!json) return;

      var data;
      try {
        data = JSON.parse(json.textContent);
      } catch (err) {
        return;
      }

      var variant = (data.variants || []).filter(function (v) {
        return String(v.id) === String(input.value);
      })[0];

      if (variant && variant.featured_media && variant.featured_media.id) {
        gallery.scrollToMedia(variant.featured_media.id);
      }
    }

    section.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') sync();
    });

    // Alguns temas alteram o input por JS, sem disparar "change".
    var input = section.querySelector('[name="id"]');
    if (input && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(input, { attributes: true, attributeFilter: ['value'] });
    }
  }

  /* ------------------------------------------------------------------ init */

  function init(scope) {
    (scope || document).querySelectorAll('[data-gricci-gallery]').forEach(function (root) {
      if (root.__gricciGallery) return;
      var gallery = new Gallery(root);
      root.__gricciGallery = gallery;
      galleries.push(gallery);
      watchVariant(root.closest('.product__section'), gallery);
    });
  }

  window.GricciGallery = {
    init: init,
    get: function (root) { return root && root.__gricciGallery; },
    all: function () { return galleries; }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Editor de temas: reinicializa ao recarregar a seção.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
